// extracted by mini-css-extract-plugin
export default {"faqItem":"styles_faqItem__ue0P9","faqArrow":"styles_faqArrow__cgegJ"};